export enum enumPbeStatus {
  'Active' = 1,
  'Inactive',
  'Suspended',
  'To Be Approved',
  'Declined'
}

export namespace enumPbeStatus {
  export function values() {
    return Object.keys(enumPbeStatus).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
